var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-container",style:({
    background: _vm.pageData ? _vm.pageData.background_color : '',
    paddingBottom: _vm.paddingBottom ? _vm.paddingBottom + 'px' : '0',
  })},[(_vm.pageData)?_c('div',{ref:"editorMain",staticClass:"editor-main"},[_vm._l((_vm.pageData.module_list),function(item){return _c('div',{key:item.module_code,staticClass:"editor-main-module-box"},[_c('div',{staticClass:"editor-main-module",on:{"click":function () { return _vm.handleReport(item, '0000'); }}},[_c(("tms-" + (item.module_code)),{tag:"component",attrs:{"isEditorStatus":false,"config":item,"theme":_vm.theme,"page-data":_vm.pageData},on:{"report":
            function (ref) {
              var btn = ref.btn;
              var type = ref.type;
              var params = ref.params;

              return _vm.handleReport(item, btn, type, params);
  }
          }})],1)])}),_vm._v(" "),(_vm.pageData.module_list.length === 0)?_c('div',{staticClass:"module-list-empty"},[_vm._v("\n      该内容暂未发布，请稍后\n    ")]):_vm._e()],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }